import script from "./BlackNamaMepandes.vue?vue&type=script&setup=true&lang=js"
export * from "./BlackNamaMepandes.vue?vue&type=script&setup=true&lang=js"

import "./BlackNamaMepandes.vue?vue&type=style&index=0&id=4d811931&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d811931"]])

export default __exports__